// Nederlands — mirrors en.js key for key. nl distinguishes one/other in CLDR.
const nl = {
  // ===== shared =====
  'common.createPlan': 'Plan maken',
  'common.save': 'Opslaan',
  'common.cancel': 'Annuleren',
  'common.delete': 'Verwijderen',
  'common.edit': 'Bewerken',
  'common.retry': 'Opnieuw proberen',
  'common.activate': 'Activeren',
  'common.deactivate': 'Deactiveren',
  'common.enabled': 'Ingeschakeld',
  'common.disabled': 'Uitgeschakeld',
  'common.viewTerms': 'Voorwaarden bekijken',
  'common.untitledPlan': 'Naamloos plan',
  'common.savedToast': 'Opslaan gelukt',

  // ===== nav / chrome =====
  'nav.home': 'Home',
  'nav.plans': 'Plannen',
  'nav.settings': 'Instellingen',

  'mismatch.title': 'Implementatieomgeving komt niet overeen',
  'mismatch.body': 'Deze frontend-build roept {apiBase} aan, maar wordt geserveerd vanaf {hostname} (verwacht: {expected}).',
  'mismatch.contact': 'Neem contact op met de technische ondersteuning — dit is een configuratiefout in de implementatie, geen probleem met je account.',

  'install.title': 'Kon geen verbinding maken met Shopify',
  'install.body': 'Controleer of de backend draait en of de SHOPIFY_API_KEY overeenkomt met de client_id van de app in shopify.app.toml.',
  'install.retry': 'Opnieuw proberen',

  'chrome.loadingBrand': 'FlexCover wordt geladen…',
  'error.title': 'Er ging iets mis',
  'error.reload': 'Herladen',

  'support.badge': 'Ondersteuningsweergave',
  'support.shopUnknown': '(onbekende winkel)',
  'support.expired': 'Token verlopen — genereer een nieuwe in de supportconsole',
  'support.validUntil': 'Token geldig tot {time}',
  'support.exit': 'Afsluiten',

  // ===== Home =====
  'home.title': 'Welkom bij FlexCover: Protection Plans 👋',
  'home.last30days': 'Laatste 30 dagen',
  'home.loadingChart': 'Grafiek wordt geladen',
  'home.loadingOverview': 'Overzicht wordt geladen',
  'home.statOrders': 'Bestellingen met plannen',
  'home.statRevenue': 'Totale planopbrengst',
  'home.gettingStarted': 'Aan de slag',
  'home.allSet': 'Alles geregeld 🎉',
  'home.completed': '{done} van {total} voltooid',
  'home.step1.title': 'Maak je eerste plan',
  'home.step1.desc': 'Stel de prijs, de dekking en de winkelwagenweergave van je beschermingsaanbod in.',
  'home.step2.title': 'Schakel de app-embed in',
  'home.step2.desc': 'Zet het blok FlexCover: Protection Plans aan zodat de widget in je winkelwagen verschijnt.',
  'home.step2.enable': 'App-embed inschakelen',
  'home.step2.check': 'Status controleren',
  'home.step3.title': 'Ontvang je eerste beschermde bestelling',
  'home.step3.desc': 'Zodra de widget live is, voegen klanten in de winkelwagen een plan toe — de totalen verschijnen in de kaarten hierboven.',
  'home.appEmbed': 'App-embed',
  'home.checkingEmbed': 'Status van de app-embed wordt gecontroleerd',
  'home.embedEnabledBody': 'De beschermingswidget staat live op je storefront.',
  'home.embedTheme': '(thema: {theme})',
  'home.embedDisabledBody': 'De app is momenteel niet actief op je storefront.',
  'home.embedUnknown': 'Onbekend',
  'home.embedUnknownBody': 'De storefrontstatus is beschikbaar zodra de app met een winkel is verbonden.',
  'home.embedUnknownReason': 'Kon je live-thema nu niet lezen.',
  'home.enableEmbedHint': 'Ga in het Shopify-beheercentrum naar Online Store → Themes → Customize → App embeds en zet FlexCover: Protection Plans aan.',
  'home.learnMorePrefix': 'Meer informatie over ',
  'home.learnMoreLink': 'het gebruik van beschermingsplannen',

  // ===== Plans list =====
  'plans.title': 'Plannen',
  'plans.loading': 'Plannen worden geladen',
  'plans.errorTitle': 'Kon plannen niet laden',
  'plans.empty.heading': 'Maak je eerste beschermingsplan',
  'plans.empty.body': 'Bied verzendbescherming, uitgebreide garanties, retourverzekering en aangepaste dekking aan — allemaal met jouw prijzen.',
  'plans.loadDemo': 'Demoplannen laden',
  'plans.demoLoaded': 'Demoplannen geladen',
  'plans.demoFailed': 'Laden van demoplannen mislukt: {message}',
  'plans.filterPlaceholder': 'Plannen filteren',
  'plans.addFilter': 'Filter toevoegen',
  'plans.statusHeading': 'Status',
  'plans.typeHeading': 'Beschermingstype',
  'plans.statusActive': 'Actief',
  'plans.statusInactive': 'Inactief',
  'plans.showing_one': '{count} plan weergegeven',
  'plans.showing_other': '{count} plannen weergegeven',
  'plans.sortBy': 'Sorteren op',
  'plans.selectAll': 'Alle plannen selecteren',
  'plans.selectedCount': '{count} geselecteerd',
  'plans.bulkDeleted_one': '{count} plan verwijderd',
  'plans.bulkDeleted_other': '{count} plannen verwijderd',
  'plans.bulkActivated_one': '{count} plan geactiveerd',
  'plans.bulkActivated_other': '{count} plannen geactiveerd',
  'plans.bulkDeactivated_one': '{count} plan gedeactiveerd',
  'plans.bulkDeactivated_other': '{count} plannen gedeactiveerd',
  'plans.deleteBulkFailed': 'Verwijderen mislukt: {message}',
  'plans.updateBulkFailed': 'Bijwerken mislukt: {message}',
  'plans.activated': 'Plan geactiveerd',
  'plans.deactivated': 'Plan gedeactiveerd',
  'plans.updateFailed': 'Bijwerken van plan mislukt: {message}',
  'plans.deleted': 'Plan verwijderd',
  'plans.deleteFailed': 'Verwijderen van plan mislukt: {message}',
  'plans.actionsFor': 'Acties voor {name}',
  'plans.activatePlan': '{name} activeren',
  'plans.deactivatePlan': '{name} deactiveren',
  'plans.onlineStore': 'Online winkel',
  'plans.optional': 'Optioneel',
  'plans.automatic': 'Automatisch',
  'plans.noMatch': 'Geen plannen komen overeen met je zoekopdracht of filters.',
  'plans.deleteTitle': 'Beschermingsplan verwijderen?',
  'plans.deleteBody': 'wordt onmiddellijk uit je winkel verwijderd. Klanten zien deze beschermingsoptie niet meer.',
  'plans.helpPrefix': 'Hulp nodig? ',
  'plans.helpLink': 'Stel ons je vraag',
  'plans.helpSuffix': ' of bekijk de documentatie en tutorials van de app.',

  'sort.date': 'Datum (nieuwste eerst)',
  'sort.name': 'Naam (A–Z)',
  'sort.sortOrder': 'Winkelwagenvolgorde',
  'sort.price': 'Prijs (laag naar hoog)',

  'planType.shipping_protection': 'Verzendbescherming',
  'planType.warranty': 'Garantie',
  'planType.return_insurance': 'Retourverzekering',
  'planType.custom': 'Aangepaste bescherming',
  'planTypeShort.shipping_protection': 'Verzending',
  'planTypeShort.warranty': 'Garantie',
  'planTypeShort.return_insurance': 'Retour',
  'planTypeShort.custom': 'Aangepast',
  'priceType.fixed': 'Vast bedrag',
  'priceType.percentage': 'Percentage van de bestelling',

  // ===== Plan editor page shell =====
  'plan.pageTitle': 'Beschermingsplan',
  'plan.loading': 'Plan wordt geladen',
  'plan.notFound.heading': 'Plan niet gevonden',
  'plan.notFound.body': 'Dit beschermingsplan is mogelijk verwijderd.',
  'plan.backToPlans': 'Terug naar de plannen',
  'plan.newTitle': 'Nieuw beschermingsplan',
  'plan.newSubtitle': 'Stel prijs en winkelwagenweergave in en maak vervolgens het plan aan',
  'plan.subtitle': 'Wijzigingen worden na het opslaan op je winkel toegepast',
  'plan.statusTitle': 'Planstatus',
  'plan.saveFailed': 'Opslaan van plan mislukt: {message}',

  // ===== Plan editor form =====
  'form.section.type': 'Beschermingstype',
  'form.section.basics': 'Basisgegevens van het plan',
  'form.section.pricing': 'Prijzen — {type}',
  'form.pricingFallback': 'Bescherming',
  'form.section.appearance': 'Weergave',
  'form.section.fulfillment': 'Afhandeling',

  'form.type.shipping_protection': 'Verzendbescherming',
  'form.type.shipping_protection.help': 'Beschermt de bestelling van de klant tegen verlies, schade of diefstal tijdens verzending.',
  'form.type.warranty': 'Garantie',
  'form.type.warranty.help': 'Dekt fabricagefouten en normale slijtage af voor een vaste periode.',
  'form.type.return_insurance': 'Retourverzekering',
  'form.type.return_insurance.help': 'Laat klanten artikelen binnen een termijn retourneren voor volledige terugbetaling.',
  'form.type.custom': 'Aangepaste bescherming',
  'form.type.custom.help': 'Je eigen aangepaste dekkingsboodschap.',

  'form.defaults.untitledPlan': 'Naamloos plan',
  'form.defaults.viewTerms': 'Voorwaarden bekijken',
  'form.defaults.shipping_protection.displayName': 'Verzendbescherming',
  'form.defaults.shipping_protection.description': 'Beschermt je bestelling tegen verlies, schade en diefstal tijdens verzending.',
  'form.defaults.warranty.displayName': 'Uitgebreide garantie',
  'form.defaults.warranty.description': 'Dekt fabricagefouten en normale slijtage gedurende 2 jaar.',
  'form.defaults.return_insurance.displayName': 'Retourverzekering',
  'form.defaults.return_insurance.description': 'Retourneer elk artikel binnen 14 dagen met volledige terugbetaling.',
  'form.defaults.custom.displayName': 'Beschermingsplan',
  'form.defaults.custom.description': 'Voeg bescherming toe aan je bestelling.',

  'form.lang.select': 'Taal selecteren',
  'form.lang.default': '{name} (standaard)',
  'form.translated': '(vertaald)',

  'form.field.planName.label': 'Plannaam (intern)',
  'form.field.planName.help': 'Alleen ter referentie — klanten zien dit nooit',
  'form.field.nameRequired': 'Interne naam is verplicht',
  'form.field.displayName.label': 'Weergavenaam',
  'form.field.displayNameRequired': 'Weergavenaam is verplicht',
  'form.field.displayName.placeholder': 'Weergavenaam',
  'form.field.displayName.help': 'Wordt aan klanten getoond in de winkelwagen en bij het afrekenen',
  'form.field.displayName.helpPreset': 'Wordt getoond aan klanten die in {lang} browsen',
  'form.field.displayName.helpPresetFallback': 'Wordt getoond aan klanten die in {lang} browsen — lege velden vallen terug op {primary}',
  'form.field.description.label': 'Omschrijving',
  'form.field.description.placeholder': 'Omschrijving',
  'form.field.description.help': 'Korte omschrijving voor klanten onder de plannaam',
  'form.field.disabledDescription.label': 'Omschrijving bij niet-geselecteerd',
  'form.field.disabledDescription.placeholder': 'Optioneel — wordt getoond als het plan niet is geselecteerd',
  'form.field.disabledDescription.help': 'Wordt getoond als het vinkje van het plan uit staat (valt bij leegte terug op de omschrijving hierboven)',
  'form.field.footer.label': 'Voettekst',
  'form.field.footerText.label': 'Voettekst',
  'form.field.footerLink.label': 'Voettekstlink',
  'form.field.footerLink.help': 'Waar de voettekst naartoe linkt',

  'form.price.type.label': 'Prijstype',
  'form.price.fixed': 'Bedrag ($)',
  'form.price.percentage': 'Percentage (%)',
  'form.price.advanced': 'Geavanceerde instelling',
  'form.price.pctSummary': '{pct}% van het bestelbedrag, vanaf ${min} in stappen van ${inc} tot ${max} — {count} varianten op het planproduct',
  'form.price.tiersSummary_one': 'Het planproduct krijgt 1 variant op {base} plus {count} intervalvariant voor de winkelwagenwaarderegels',
  'form.price.tiersSummary_other': 'Het planproduct krijgt 1 variant op {base} plus {count} intervalvarianten voor de winkelwagenwaarderegels',

  'form.validation.priceRequired': 'Voer een waarde groter dan 0 in',
  'form.validation.priceMax100': 'Het percentage mag niet hoger zijn dan 100',
  'form.validation.warrantyYears': 'Voer een duur tussen 1 en 5 jaar in',
  'form.validation.returnDays': 'Voer een termijn tussen 7 en 365 dagen in',
  'form.validation.maxGreaterThanMin': 'Het maximum moet groter zijn dan het minimum',
  'form.validation.variantIdNumeric': 'De variant-id moet numeriek zijn (de id van de verborgen planvariant)',

  'form.icon.label': 'Icoon',
  'form.icon.useEmoji': '{emoji} als planicoon gebruiken',
  'form.icon.removeCustom': 'Het aangepaste icoon verwijderen en het schild-icoon gebruiken',
  'form.icon.upload': 'Een aangepast icoonbeeld uploaden',
  'form.icon.uploadButton': 'Uploaden',
  'form.icon.uploading': 'Icoon wordt geüpload',
  'form.icon.uploadHelp': 'Upload je eigen icoon — PNG, JPEG, GIF of WebP, tot 5 MB.',
  'form.icon.error.notImage': 'Kies een afbeeldingsbestand (PNG, JPEG, GIF of WebP).',
  'form.icon.error.tooLarge': 'De afbeelding mag maximaal 5 MB zijn.',

  'form.fulfillment.intro': 'Kies wanneer het beschermingsproduct als afgehandeld wordt gemarkeerd.',
  'form.fulfillment.manually': 'Handmatig afhandelen',
  'form.fulfillment.first_item': 'Als afgehandeld markeren zodra het eerste artikel van de bestelling is afgehandeld',
  'form.fulfillment.all_items': 'Als afgehandeld markeren zodra alle andere artikelen van de bestelling zijn afgehandeld',
  'form.fulfillment.immediately': 'Direct na het maken van de bestelling als afgehandeld markeren',

  'form.adv.title': 'Geavanceerde instelling',
  'form.adv.minPrice': 'Minimumprijs',
  'form.adv.minPriceHelp': 'De prijs van de eerste variant — het laagste bedrag dat het plan rekent',
  'form.adv.increment': 'Incrementbedrag',
  'form.adv.incrementHelp': 'Prijstap tussen de gegenereerde varianten',
  'form.adv.maxPriceLabel': 'Maximumprijs: ',
  'form.adv.explanation': 'Het planproduct wordt gegenereerd met {buckets} varianten: de minimumprijs {min} neemt één variant in en de resterende {rest} varianten stappen met {inc} omhoog, tot een maximumprijs van {max}. Bij het afrekenen betaalt de klant de eerste variant met een prijs op of boven {pct}% van het winkelwagensubtotaal — een winkelwagen van $100 bij 2% richt op $2.00, dus de variant van $3.01 geldt. ',
  'form.learnMore': 'Meer informatie',

  'form.tiers.title': 'Prijs instellen op winkelwagenwaarde',
  'form.tiers.minCol': 'Minimale winkelwagenwaarde',
  'form.tiers.maxCol': 'Maximale winkelwagenwaarde',
  'form.tiers.priceCol': 'Beschermingsprijs',
  'form.tiers.addTier': 'Nieuwe regel toevoegen',
  'form.tiers.deleteTier': 'Regel {index} verwijderen',
  'form.tiers.explanation': 'Elke regel heeft een minimum, een maximum en een prijs nodig (regels mogen overlappen — de eerste passende regel geldt). Elke regel wordt een eigen variant op het planproduct. Komt het winkelwagentotaal met geen enkele regel overeen, dan geldt de vaste prijs uit de hoofdinstelling. ',
  'form.tiers.error.minRequired': 'Minimale winkelwagenwaarde is verplicht',
  'form.tiers.error.maxRequired': 'Maximale winkelwagenwaarde is verplicht',
  'form.tiers.error.priceRequired': 'Beschermingsprijs is verplicht',
  'form.tiers.error.pricePositive': 'De prijs moet groter zijn dan 0',
  'form.tiers.error.minMax': 'Het minimum moet kleiner of gelijk aan het maximum zijn',

  // ===== Save bar =====
  'savebar.unsavedChanges': 'Niet-opgeslagen wijzigingen',
  'savebar.discard': 'Weggooien',
  'savebar.saving': 'Opslaan…',

  // ===== Preview panel =====
  'preview.title': 'Voorbeeld',
  'preview.simulatedSubtotal': 'Gesimuleerd winkelwagensubtotaal',
  'preview.cart': 'Winkelwagen',
  'preview.product': 'PRODUCT',
  'preview.total': 'TOTAAL',
  'preview.subtotal': 'Subtotaal',
  'preview.checkout': 'Afrekenen',
  'preview.noPlans': 'Nog geen actieve plannen — klanten zien deze widget niet.',
  'preview.autoAdded': 'Automatisch toegevoegd',
  'preview.unsaved': 'Niet opgeslagen',

  // ===== Settings page =====
  'settings.title': 'Instellingen',
  'settings.language.title': 'Taalvoorkeur',
  'settings.language.help': 'Wanneer je FlexCover bezoekt, is dit de taal die voor jou wordt getoond. De taal van je winkel wordt niet beïnvloed.',
  'settings.language.label': 'Taal',
  'settings.language.updated': 'Taal bijgewerkt',
  'settings.language.saveFailed': 'Opslaan van taalvoorkeur mislukt: {message}'
};

export default nl;
